// The Day Care module's sidebar: the shared ModuleSidebarLayout (the shell
// Inventory and Lab use), so the module reads as one contained app like every
// other HMIS module. Items needing a permission the user lacks are left out.

import React, { useMemo } from "react";

import ModuleSidebarLayout from "../../inventory/components/ModuleSidebarLayout";
import { usePermissions } from "../../login/PermissionContext";
import { NAV_CONFIG } from "../constants";

export default function DaycareLayout({ children }) {
  const { permissions = [], userInfo } = usePermissions();
  const isSuperAdmin = userInfo?.role_permission?.[0]?.role === "super admin";

  const navConfig = useMemo(() => {
    const allowed = (item) =>
      !item.permission
      || isSuperAdmin
      || permissions.some((p) => p.permission_name === item.permission && p.is_accessible);
    const groups = NAV_CONFIG.groups
      .map((group) => ({ ...group, items: group.items.filter(allowed) }))
      .filter((group) => group.items.length);
    return { ...NAV_CONFIG, groups };
  }, [permissions, isSuperAdmin]);

  return (
    <ModuleSidebarLayout navConfig={navConfig} suiteBase="" storageKey="daycare_sidebar_expanded" disableContentPadding>
      {children}
    </ModuleSidebarLayout>
  );
}
